import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VLazyImage from "v-lazy-image"
import appConfig from './config/appConfig'

import './styles/global.css'

// Log build version in console (injected by vue.config.js)
if (typeof __BUILD_VERSION__ !== 'undefined') {
  console.log(`%c Website v${__BUILD_VERSION__}`, 'color: #409EFF; font-weight: bold;')
  window.__APP_VERSION__ = __BUILD_VERSION__
}

const app = createApp(App)

app.component("v-lazy-image", VLazyImage)
app.config.globalProperties.$config = appConfig

app.use(router).mount('#app')